import React, { useState, useEffect } from 'react';
import MicRecorder from 'mic-recorder-to-mp3';
import io from 'socket.io-client';
import axios from 'axios';
import { FaPlay, FaPause, FaFileAudio } from 'react-icons/fa';
import { alert_error, alert_success } from "../../AppContext.js";
import { useParams } from 'react-router-dom';
import { RingLoader } from "react-spinners";
import { TiTick } from 'react-icons/ti';
import AudioPlayer from '../../app_structure/AudioPlayer';
import Select from 'react-select';
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const Recordaudio = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [socumphat, setsocumphat] = useState(0);
    const [isRecording, setIsRecording] = useState(false);
    const [service, setservice] = useState(false);
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState("Xác nhận 📝🌐");
    const [blobdata, setblobdata] = useState(null);
    const [caption, setcaption] = useState(null);
    const [dalaythongtin, setdalaythongtin] = useState(false);
    const [thongtincum, setthongtincum] = useState(false);
    const [ToChucIds, setToChucIds] = useState(false);
    const { slug_2 } = useParams();
    const [ThietBiId, setThietBiId] = useState([]);
    const [src, setsrc] = useState('');
    const [tenfile, settenfile] = useState(false);
    const [dungghi, setdungghi] = useState(false);
    const [isOpen2, setIsOpen2] = useState(true);
    const [them20giay, setthem20giay] = useState('NO');
    const [options2, setOptions2] = useState([
        { label: 'Phát luôn ra loa', value: 'voice' },
        { label: 'Gốc cho Cụm internet', value: 'NO' },
        { label: 'Thêm 20 giây Cụm FM', value: 'YES' },
    ]);
    console.log(slug_2);
    useEffect(() => {
        laythongtin();
    }, []);
    function laythongtin() {
        axios.get('https://hust.media/truyenthanh/usercum.php', {
            params: {
                username: slug_2
            }
        })
            .then(response => {
                console.log(response.data); // Dữ liệu từ API
                setdalaythongtin(true);
                setthongtincum(response.data.Data);
                setToChucIds(parseInt(response.data.ToChucIds));
                console.log(ToChucIds); // 7134

                // Xử lý dữ liệu ở đây
            })
            .catch(error => {
                alert_error(error);
            });
    };
    function handleClick(itemId) {
        // Kiểm tra xem phần tử đã được chọn hay chưa
        const isSelected = ThietBiId.includes(itemId);

        // Nếu đã chọn, loại bỏ khỏi danh sách
        // Nếu chưa chọn, thêm vào danh sách
        const shdfbjhsdfbj = isSelected ? ThietBiId.filter(id => id !== itemId) : [...ThietBiId, itemId];
        setThietBiId(shdfbjhsdfbj);
        setsocumphat(shdfbjhsdfbj.length);
        console.log(socumphat);
    };


    function handleSubmit(event) {

        // const apikey = Cookies.get("apikey");
        event.preventDefault();

        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!ToChucIds || !ThietBiId || !caption) {
            alert_error("Đã xảy ra lỗi vui lòng liên hệ đội ngũ hỗ trợ" + caption);
            setnutxuly(0);
            setnutorder("Đặt lại");
            return;
        }

        const urlapiok = 'https://test.tecom.pro:2999/daylenfile' + '?username=' + slug_2 + '&ThietBiId=' + ThietBiId
            + '&ToChucIds=' + ToChucIds + '&caption=' + caption + '&tenfile=' + tenfile + '&service=' + service;
        axios.post(urlapiok)
            .then((response) => {
                setnutxuly(0);
                alert_success('Thành công');
                setnutorder("Xác nhận");
                setIsRecording(false);
                setIsRecordingok(false);
                console.log(response);
            })
            .catch((error) => {
                setnutxuly(0);
                setnutorder("Đặt lại");
                alert_error(error);
                setIsRecording(false);
                setIsRecordingok(false);
            });
    }


    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileName = file.name;
            setSelectedFile(file);
            setcaption(fileName);
            console.log(`Tên tệp: ${fileName}`);
        }
    };
    const [isRecordingok, setIsRecordingok] = useState(false);

    const handleRecording = () => {
        if (!isRecording) {
            if (!selectedFile) {
                alert_error('Hãy chọn một tệp âm thanh trước.');
                return;
            }
            else if ( socumphat == '0') {
                alert_error('chưa chọn cụm');
                return;
            }
            setIsRecordingok(true);
            // Chuyển đổi tệp âm thanh thành Blob
            const reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);
            reader.onload = () => {
                const audioBlob = new Blob([reader.result], { type: selectedFile.type });

                // Bây giờ bạn có thể gửi audioBlob qua API bằng Axios
                // Thay thế URL dưới đây bằng URL API thực tế của bạn
                const apiUrl = 'https://tecom.pro/truyenthanh/file/getaudio.php?service=' + service;

                const formData = new FormData();
                formData.append('audio', audioBlob);

                axios.post(apiUrl, formData)
                    .then((response) => {
                        setIsRecording(true);
                        setIsRecordingok(false);
                        setsrc('https://tecom.pro/truyenthanh/file/' + response.data);
                        settenfile(response.data);
                        console.log('Phản hồi từ API:', response.data);
                    })
                    .catch((error) => {
                        alert_error('Lỗi khi gửi tệp âm thanh:', error);
                    });
            };
        }
        else {
            setIsRecording(false);
            setsrc('');
        }
    };
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };

    const handleBlur2 = () => {
        setIsOpen2(false);
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };
    const handleChange2 = (selectedOption2) => {
        setthem20giay(selectedOption2.value);
        setservice(selectedOption2.value);
        setIsOpen2(false);
    };

    return (
        <>
            {
                dungghi ? (<div className="flex justify-center items-center">
                    <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
                </div>
                ) : !dalaythongtin && !thongtincum ? (<div className="flex justify-center items-center">
                    <RingLoader size={80} color="#0000ff" loading={dalaythongtin} />{" "}
                </div>
                ) : (
                    <div className="max-w-2xl px-1 py-4   mx-auto rounded-lg shadow-xl ">
                        <div className="container-fluid mt-0  flex  flex-col  items-center justify-center">
                            <label htmlFor="countries2" className="text-center text-xs  mb-1  font-medium">
                                Chọn kiểu chuyển
                            </label>
                            <Select
                                className="w-full max-w-md"
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus2}
                                options={options2}
                                menuIsOpen={isOpen2}
                                onBlur={handleBlur2}
                                onMenuOpen={handleMenuOpen2}
                                onChange={handleChange2} // Use selectedOption.value to get the selected value
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            />
                            {!isRecording && (
                                <>
                                    <div className=" items-center justify-center ">
                                        <label
                                            htmlFor="fileInput"
                                            className="mt-2 flex flex-col max-w-md items-center px-4 py-6 bg-white text-blue-700 rounded-lg shadow-lg tracking-wide border border-blue-700 cursor-pointer hover:bg-blue-700 hover:text-pink-500"
                                        >
                                            <FaFileAudio className="w-8 h-8" />
                                            {
                                                caption ? (<>  <span className="break-all mt-2 text-base text- whitespace-normal">{caption}</span></>) :
                                                    (<>  <span className="mt-2 text-base whitespace-normal">Chọn tệp âm thanh</span></>)
                                            }

                                            <input
                                                type="file"
                                                id="fileInput"
                                                accept=".mp3, .wav, .m4a"
                                                className="hidden"
                                                onChange={handleFileSelect}
                                            />
                                        </label>
                                    </div>
                                </>

                            )}
                            <div className="mt-3 relative inline-block">
                                <button
                                    className={`bg-green-500 hover:bg-green-600 text-white rounded-full w-12 h-12 flex items-center justify-center ' : ''
                                        }`}
                                    onClick={handleRecording}
                                    disabled={isRecordingok}
                                >
                                    {isRecording ? (
                                        <FaPause className="text-xl" />
                                    ) : (
                                        <FaPlay className="text-xl" />
                                    )}
                                    {isRecordingok && (
                                        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                                            <div className="absolute w-14 h-14 bg-green-500 opacity-50 rounded-full animate-pulse"></div>
                                            <div className="absolute w-16 h-16 bg-green-500 opacity-20 rounded-full animate-pulse"></div>
                                            <div className="absolute w-18 h-18 bg-green-500 opacity-10 rounded-full animate-pulse"></div>
                                        </div>
                                    )}
                                </button>


                            </div>{isRecording && (
                                <>

                                    <AudioPlayer src={src} onReset={handleRecording} />
                                    <button disabled={nutxuly == 1}
                                        onClick={handleSubmit}
                                        className="my-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-0 w-full dark:bg-slate-800 dark:text-white"
                                    >
                                        <div className="flex items-center justify-between flex-1">
                                            {nutxuly == 1 && (
                                                <div className="spinner-border" role="status"></div>
                                            )}

                                            <span className="text-lg font-medium text-white">
                                                {nutorder}{" "}
                                            </span>
                                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                        </div>
                                    </button> </>
                            )}

                        </div>
                        <div className="grid mt-3 grid-cols-2 gap-4">
                            {thongtincum.map((item) => (
                                <div
                                    key={item.Id}
                                    className={`bg-gray-200 p-4 rounded-lg cursor-pointer ${ThietBiId.includes(item.Id) ? 'bg-green-200' : ''
                                        }`}
                                    onClick={() => handleClick(item.Id)}
                                >
                                    <div className="flex items-center justify-center mb-2">
                                        {ThietBiId.includes(item.Id) && (
                                            <TiTick className="w-10 h-10 text-green-500" />
                                        )}
                                    </div>
                                    <p className="text-center">{item.TenThietBi}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
        </>
    );
};

export default Recordaudio;
